
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const planRevenueData = [
  { month: 'Jan', basic: 2500, pro: 4500, enterprise: 8000 },
  { month: 'Feb', basic: 2700, pro: 4800, enterprise: 8500 },
  { month: 'Mar', basic: 2900, pro: 5100, enterprise: 9000 },
  { month: 'Apr', basic: 3100, pro: 5400, enterprise: 9500 },
  { month: 'May', basic: 3300, pro: 5700, enterprise: 10000 },
  { month: 'Jun', basic: 3500, pro: 6000, enterprise: 10500 },
  { month: 'Jul', basic: 3700, pro: 6300, enterprise: 11000 },
  { month: 'Aug', basic: 3900, pro: 6600, enterprise: 11500 },
  { month: 'Sep', basic: 4100, pro: 6900, enterprise: 12000 },
  { month: 'Oct', basic: 4300, pro: 7200, enterprise: 12500 },
  { month: 'Nov', basic: 4500, pro: 7500, enterprise: 13000 },
  { month: 'Dec', basic: 4700, pro: 7800, enterprise: 13500 },
];

const BusinessPlanRevenueCard = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Revenue by Business Plan</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[400px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={planRevenueData}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis tickFormatter={(value) => `$${value}`} />
              <Tooltip 
                formatter={(value) => [`$${value}`, 'Revenue']}
                labelFormatter={(label) => `Month: ${label}`}
              />
              <Legend />
              <Bar dataKey="basic" name="Basic Plan" fill="#93c5fd" />
              <Bar dataKey="pro" name="Pro Plan" fill="#4f46e5" />
              <Bar dataKey="enterprise" name="Enterprise Plan" fill="#22c55e" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default BusinessPlanRevenueCard;
